import React, { useEffect, useState, useRef } from "react";

import Pagination from "../../../components/Pagination";
import Modal from "react-modal";
import SupportHttp from "../../../hooks/support-http";
import { toast } from "react-toastify";

const Support = () => {
  const attachmentFolder = localStorage.getItem("attachmentFolder");
  const [attachmentUrl, setAttachmentUrl] = useState();
  const [data, setData] = useState();
  const frmRef = useRef({});
  const AttachmentUpload = (e) => {
    const picData = new FormData();
    const file = e.target.files[0];
    picData.append("fileUpload", file, file.name);
    fetch(
      `${
        process.env.REACT_APP_BASE_URL
      }/api/file/${attachmentFolder}/support/${new Date().valueOf()}/${file.name}`,
      {
        method: "POST",
        body: picData,
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setAttachmentUrl(data.url);
      })
      .catch((err) => console.error(err));
  };

  const { sendRequest: postSupport } = SupportHttp();

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      typeOfSupport: frmRef.current.support_type.value,
      supportTitle: frmRef.current.title.value,
      supportDescription: frmRef.current.description.value,
      fileAttachment: attachmentUrl,
      urlAttachment: attachmentUrl,
      customerCode: localStorage.getItem("orgCode"),
      reporterEmail: localStorage.getItem("userEmail"),
      contactNo: localStorage.getItem("userContact"),
      name: localStorage.getItem("employeeName"),
      userId: localStorage.getItem("id"),
      status: 1,
    };

    //console.log(data);
    postSupport(
      {
        url: "/api/support/",
        method: "POST",

        body: data,
      },
      (data) => {
        //  //console.log(data);
        toast.success("Request send Successfully");
        getAllRequests();
        frmRef.current.support_type.value = "";
        frmRef.current.title.value = "";
        frmRef.current.description.value = "";
        setAttachmentUrl("");
      },
      (error) => {
        //  console.error("Error:", error);
        toast.error(error);
      }
    );
  };

  const { sendRequest: getRequests } = SupportHttp();

  const getAllRequests = () => {
    getRequests(
      {
        url: `/api/support/?userId=${localStorage.getItem(
          "id"
        )} &customerCode=${localStorage.getItem("orgCode")}`,
      },
      (res) => {
        if (res) {
          //  //console.log(res);
          setData(res);
        }
      }
    );
  };

  useEffect(() => {
    getAllRequests();
  }, []);

  const [itemsPerPage] = useState(10);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Support</label>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={handleSubmit}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Support Type</label>
                        <select
                          className="form-control"
                          style={{ width: "100%" }}
                          ref={(el) => (frmRef.current["support_type"] = el)}
                          autoComplete="off"
                          required
                        >
                          <option value="">Select</option>
                          <option value="1">Functional</option>
                          <option value="2">Technical</option>
                        </select>
                      </div>
                    </div>
                    {/* /.col */}
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Title</label>

                        <input
                          type={"text"}
                          id={"title"}
                          required
                          ref={(el) => (frmRef.current["title"] = el)}
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Description</label>

                        <input
                          type={"text"}
                          id={"Description"}
                          required
                          ref={(el) => (frmRef.current["description"] = el)}
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label for="exampleInputFile">File input</label>
                        <div className="input-group">
                          <div className="custom-file">
                            <input
                              type="file"
                              className="custom-file-input"
                              id="file"
                              accept="image/*"
                              // value={attachmentUrl ||""}
                              onChange={AttachmentUpload}
                            />
                            <label
                              className="custom-file-label"
                              for="exampleInputFile"
                            >
                              {attachmentUrl
                                ? attachmentUrl.split("/")[3]
                                : "Choose file"}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="text-center">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Support Type</th>
                          <th>Support Title</th>
                          <th>Email id</th>
                          <th>Contact Number</th>
                          <th>Description</th>
                          <th>Image</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>
                                  {itm.typeOfSupport == 1
                                    ? "Functional"
                                    : "Technical"}
                                </td>
                                <td>{itm.supportTitle}</td>
                                <td>{itm.reporterEmail}</td>
                                <td>{itm.contactNo}</td>

                                <td>{itm.supportDescription}</td>
                                <td>
                                  {" "}
                                  <img
                                    src={`${process.env.REACT_APP_FILE_URL}${itm.urlAttachment}`}
                                    className="user-image img-circle"
                                    width="60"
                                    height="60"
                                    alt="User Image"
                                  />
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data && data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Support;
